export default __webpack_public_path__ + "static/media/extender.56e84d8a.svg";